export const FullPageLoader = () => {
  return (
    <>
      <div className="w--full h--full d--flex justify-content--center align-items--center">
        <div className="reverse-spinner "></div>
      </div>
    </>
  );
};
export const LinerLoader = () => {
  return <p>LinerLoader</p>;
};
export const Spinner = ({ size = 'sm' }) => {
  return <span className={`spinner spinner--${size}`}></span>;
};
